/**
 * Core types that are foundational to the type system.
 * These types have no dependencies on other type files to avoid circular imports.
 */

/**
 * A unique database ID that consists of 24 hexadecimal characters.
 *
 * @example af5e1b3b1f7b1b001f7b1b00
 */
export type ArdoqId = string;

export type Email = string;

export type Url = string;

declare const timezoneBrand: unique symbol;
export type Timezone = string & { readonly [timezoneBrand]: never };

export type Entity = { _id: ArdoqId };

export type Versioned = { _version: number };

export type VersionedEntity = Entity & Versioned;

export type Maybe<T> = T | null;

export type MetaData = {
  created: string;
  createdBy: ArdoqId;
  createdByEmail: Email;
  createdByName: string;
  lastModifiedBy: ArdoqId;
  lastModifiedByEmail: Email;
  lastModifiedByName: string;
  lastUpdated: string;
};

/**
 * Standard attributes stored and returned by the API
 */
export type Persisted<T = Record<string, unknown>> = MetaData & Entity & T;

export type WithTransactionId = {
  transactionId?: string;
};

export const SYMBOL_TRANSACTION_ID = Symbol('transactionId');

export type WithSymbolTransactionId = {
  [SYMBOL_TRANSACTION_ID]?: string;
};
